// shadcn/ui component: https://ui.shadcn.com/docs/components/radix/radio-group
import React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { cn } from 'src/component/ds/utils';

/* "Radio - Vega" / "Radio Group - Vega" in Figma: 16x16 circle, 8x8 dot. */
const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Root ref={ref} className={cn('ds-grid ds-gap-2', className)} {...props} />
));
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Item
    ref={ref}
    className={cn(
      'ds-peer ds-h-4 ds-w-4 ds-shrink-0 ds-rounded-full',
      'ds-border ds-border-input ds-bg-background ds-shadow-ds-2xs',
      'focus-visible:ds-outline-none focus-visible:ds-shadow-ds-focus',
      'disabled:ds-cursor-default disabled:ds-opacity-50',
      'data-[state=checked]:ds-bg-primary data-[state=checked]:ds-border-primary',
      'aria-[invalid=true]:ds-border-destructive',
      'aria-[invalid=true]:data-[state=checked]:ds-bg-destructive',
      'aria-[invalid=true]:focus-visible:ds-shadow-ds-focus-error',
      className
    )}
    {...props}
  >
    {/* The indicator must fill the 16px item, or the 8px dot isn't centred. */}
    <RadioGroupPrimitive.Indicator className='ds-flex ds-h-full ds-w-full ds-items-center ds-justify-center'>
      <span className='ds-block ds-h-2 ds-w-2 ds-rounded-full ds-bg-primary-foreground' />
    </RadioGroupPrimitive.Indicator>
  </RadioGroupPrimitive.Item>
));
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
